import { render } from "./sd-wind.vue?vue&type=template&id=05b5fc99&scoped=true"
import script from "./sd-wind.vue?vue&type=script&lang=js"
export * from "./sd-wind.vue?vue&type=script&lang=js"

import "./sd-wind.vue?vue&type=style&index=0&id=05b5fc99&scoped=true&lang=css"

import exportComponent from "E:\\vue_yclcp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05b5fc99"]])

export default __exports__